module.exports = __webpack_public_path__ + "img/1723599157784-image.jpg.570d6ae1.webp";